import { createReducer, on } from '@ngrx/store';

import {
    loadPlayerStatisticsData,
    playerStatisticsDataFailure,
    playerStatisticsDataSuccess,
    resetPlayerStatisticsState,
    setPlayerStatisticsOpenAndTrackingStatus,
} from './player-statistics.actions';
import { playerStatisticsInitialState } from './player-statistics.state';

export const playerStatisticsReducer = createReducer(
    playerStatisticsInitialState,
    on(loadPlayerStatisticsData, (state, { eventId, marketFilter, mainMarket }) => {
        const existingStats = state[eventId]?.[mainMarket ? 'mainMarket' : marketFilter];
        if (!existingStats) {
            return {
                ...state,
                [eventId]: {
                    ...state[eventId],
                    [mainMarket ? 'mainMarket' : marketFilter]: { isLoading: true, data: undefined, isError: false },
                },
            };
        }
        return state;
    }),
    on(playerStatisticsDataSuccess, (state, { eventId, marketFilter, mainMarket, data, isLoading, isError }) => ({
        ...state,
        [eventId]: {
            ...state[eventId],
            [mainMarket ? 'mainMarket' : marketFilter]: { data, isLoading, isError },
        },
    })),
    on(playerStatisticsDataFailure, (state, { eventId, marketFilter, mainMarket, data, isLoading, isError }) => ({
        ...state,
        [eventId]: {
            ...state[eventId],
            [mainMarket ? 'mainMarket' : marketFilter]: { data, isLoading, isError },
        },
    })),
    on(resetPlayerStatisticsState, (state) => playerStatisticsInitialState),
    on(setPlayerStatisticsOpenAndTrackingStatus, (state, { eventId, marketFilter, mainMarket, playerName, marketId, isOpen, tracking }) => {
        const storeData = state[eventId]?.[mainMarket ? 'mainMarket' : marketFilter];
        if (!storeData) {
            return state;
        }
        const playerStatistics = storeData.data?.playerStatistics ?? [];
        const matchPlayer = playerStatistics?.find((player) => {
            return player.playerName === playerName && player.marketId === marketId;
        });
        if (!matchPlayer) {
            playerStatistics?.push({
                playerName: playerName,
                marketId: marketId ?? '',
                isOpen,
                tracking,
            });
        } else {
            matchPlayer.isOpen = isOpen === undefined ? matchPlayer.isOpen : isOpen;
            matchPlayer.tracking = tracking === undefined ? matchPlayer.tracking : tracking;
        }
        const statisticsData = {
            ...storeData.data,
            playerStatistics,
        };
        return {
            ...state,
            [eventId]: {
                ...state[eventId],
                [mainMarket ? 'mainMarket' : marketFilter]: {
                    ...storeData,
                    data: statisticsData,
                },
            },
        };
    }),
);
